import { useContext } from 'react';
import { PublicLayout, PublicLayoutContext } from 'context';

const usePublicLayout = (): PublicLayout => useContext(PublicLayoutContext);

export default usePublicLayout;
